'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _theme = require('@hixme-ui/theme');

var _theme2 = _interopRequireDefault(_theme);

var _themeProps = require('@hixme-ui/theme-props');

var _themeProps2 = _interopRequireDefault(_themeProps);

var _list = require('./list');

var _list2 = _interopRequireDefault(_list);

var _StyledIconContainer = require('./StyledIconContainer');

var _StyledIconContainer2 = _interopRequireDefault(_StyledIconContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// project
var icons = (0, _keys2.default)(_list2.default);

var getIcon = function getIcon(props) {
  var iconName = icons.find(function (name) {
    return props[name];
  });

  if (!iconName) {
    console.warn('hixme-ui:Icon - icon not provided or not found`'); // eslint-disable-line no-console
  } else {
    return _list2.default[iconName];
  }
  return null;
};

var getFontSize = function getFontSize(_ref) {
  var fontSize = _ref.fontSize,
      size = _ref.size;
  return fontSize * size + 'px';
};
var getIconColor = function getIconColor(props) {
  return (0, _themeProps2.default)((0, _extends3.default)({ theme: _theme2.default }, props), _theme2.default.textColors.default);
};

var Icon = function Icon(props) {
  var color = props.color;

  var UseIcon = getIcon(props);
  return _react2.default.createElement(
    _StyledIconContainer2.default,
    { size: getFontSize(props) },
    _react2.default.createElement(UseIcon, {
      color: color || getIconColor(props),
      fill: color || getIconColor(props),
      style: { maxHeight: getFontSize(props) }
    })
  );
};

Icon.displayName = 'hui:Icon';
Icon.huiName = 'Icon';

/* eslint-disable react/no-unused-prop-types */
Icon.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  fontSize: _propTypes2.default.number
};

Icon.defaultProps = {
  color: null,
  size: 1,
  fontSize: 14
};

exports.default = Icon;
//# sourceMappingURL=Icon.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icon.js
// module id = 266
// module chunks = 0